import {
  SourceInterface,
  SourcePicker,
  useSource,
  useTranslation,
} from "@opendash/core";

import { stringToTag } from "@opendash/ui";
import { Button, Flex, Input, Modal, Typography, UploadFile } from "antd";
import React, { useState } from "react";
import { PDFUploader, useSaveSourceFiles } from "../../..";

interface Props {
  open: boolean;
  onClose: () => void;
}

export default (props: Props) => {
  const t = useTranslation();
  const { saveFiles, saving } = useSaveSourceFiles();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [headlinesource] = useSource();
  const [source, setSource] = useState<SourceInterface>(headlinesource);
  const [description, setDescription] = useState<string[]>([]);

  const descriptionInputs = fileList.map((file, index) => {
    return (
      <div key={file.uid}>
        <Typography.Text>
          {stringToTag(
            t("maintenance:knowledge.modal.upload.label.description", {
              name: file.name,
            }),
            "'"
          )}
        </Typography.Text>
        <Input.TextArea
          value={description[index]}
          onChange={(e) =>
            setDescription((prev) => {
              const newDescription = [...prev];
              newDescription[index] = e.currentTarget.value;
              return newDescription;
            })
          }
        />
      </div>
    );
  });

  function onChancelUpload() {
    setFileList([]);
    setDescription([]);
    setSource(undefined);
    props.onClose();
  }

  async function handleUpload() {
    await saveFiles(fileList, source, description);
    onChancelUpload();
  }

  return (
    <Modal
      title={t("maintenance:knowledge.admin.upload.button.title")}
      open={props.open}
      onCancel={onChancelUpload}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={handleUpload}
          disabled={!source || saving}
          loading={saving}
        >
          {t("maintenance:knowledge.admin.modal.upload.title")}
        </Button>,
      ]}
    >
      <Flex gap="16px" vertical>
        <div>
          <Typography.Text>
            {t("maintenance:knowledge.admin.table.source.label")}
          </Typography.Text>
          <SourcePicker
            onChange={(value) => setSource(value)}
            value={source}
            style={{ width: "100%" }}
          />
        </div>
        <PDFUploader
          value={fileList}
          disabled={saving || !source}
          onChange={(files) => setFileList(files)}
        />
        {descriptionInputs}
      </Flex>
    </Modal>
  );
};
